// ----------------------------------------------------------------------------
// Component: Content Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_content-panel.scss';

// Content Panel - Video
import 'snippets/video-player/video-block';
import 'snippets/_containers/modal/modal';
